import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { T, Lang } from '../lib/i18n';
export function Contact({
  lang,
  openPrivacy
}: {
  lang: Lang;
  openPrivacy: () => void;
}) {
  const t = T[lang].contact;
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('sending');
    const form = e.currentTarget;
    const formData = new FormData(form);
    try {
      const res = await fetch('https://formsubmit.co/ajax/arvexholdingllc@gmail.com', {
        method: 'POST',
        body: formData
      });
      if (res.ok) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
      }
    } catch (err) {
      setStatus('error');
    }
  };
  return <section id="contacto" className="bg-white py-24 px-4 md:px-8 relative overflow-hidden" data-id="element-15">
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-brand-blue-primary/5 rounded-full blur-3xl translate-y-1/3 translate-x-1/3 pointer-events-none" data-id="element-16"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-17">
        <div className="text-center mb-16" data-id="element-18">
          <div className="inline-block bg-brand-blue-primary/10 text-brand-blue-primary text-sm font-bold px-3 py-1 rounded-full mb-4" data-id="element-19">
            {t.tag}
          </div>
          <h2 className="font-display font-extrabold text-3xl md:text-5xl text-brand-navy-dark mb-4" data-id="element-20">
            {t.h2_1}
            <span className="bg-gradient-brand bg-clip-text text-transparent" data-id="element-21">
              {t.h2_2}
            </span>
          </h2>
          <p className="text-brand-text-muted max-w-xl mx-auto text-lg" data-id="element-22">
            {t.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-23">
          {/* Left - WhatsApp */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-[#25d366]/5 to-white border border-[#25d366]/20 rounded-[20px] p-8 md:p-10 shadow-sm" data-id="element-24">
            <div className="text-5xl mb-6" data-id="element-25">💬</div>
            <h3 className="font-display font-bold text-2xl text-brand-navy-dark mb-2" data-id="element-26">
              {t.wa_title}
            </h3>
            <p className="text-brand-text-muted mb-8" data-id="element-27">{t.wa_sub}</p>

            <div className="font-display font-black text-3xl text-[#25d366] mb-8" data-id="element-28">
              +1 (689) 287-6483
            </div>

            <a href={`https://wa.me/16892876483?text=${encodeURIComponent(t.wa_msg)}`} target="_blank" rel="noreferrer" className="flex items-center justify-center space-x-2 w-full bg-[#25d366] text-black py-4 rounded-xl font-bold hover:bg-[#20ba56] transition-colors mb-6 shadow-md" data-id="element-29">
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-30">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" data-id="element-31" />
              </svg>
              <span data-id="element-32">{t.wa_title}</span>
            </a>

            <p className="text-xs text-brand-text-muted text-center font-medium" data-id="element-33">
              {t.wa_note}
            </p>
          </motion.div>

          {/* Right - Form */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white border border-brand-blue-primary/10 rounded-[20px] p-8 md:p-10 shadow-lg" data-id="element-34">
            <h3 className="font-display font-bold text-2xl text-brand-navy-dark mb-2" data-id="element-35">
              {t.f_title}
            </h3>
            <p className="text-brand-text-muted text-sm mb-8" data-id="element-36">{t.f_sub}</p>

            {status === 'success' ? <div className="bg-green-50 border border-green-200 text-green-700 p-6 rounded-xl text-center" data-id="element-37">
                <div className="text-4xl mb-4" data-id="element-38">✅</div>
                <p className="font-bold" data-id="element-39">{t.f_success}</p>
              </div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-40">
                <input type="hidden" name="_subject" value={`New lead from Arvex — {name} ({package})`} data-id="element-41" />
                <input type="hidden" name="_template" value="table" data-id="element-42" />
                <input type="hidden" name="_captcha" value="false" data-id="element-43" />

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-44">
                  <input required type="text" name="name" placeholder={t.f_name} className="w-full px-4 py-3 rounded-lg border border-brand-blue-primary/15 focus:outline-none focus:ring-2 focus:ring-brand-blue-primary/50 text-sm" data-id="element-45" />
                  <input required type="text" name="business" placeholder={t.f_biz} className="w-full px-4 py-3 rounded-lg border border-brand-blue-primary/15 focus:outline-none focus:ring-2 focus:ring-brand-blue-primary/50 text-sm" data-id="element-46" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-47">
                  <input required type="email" name="email" placeholder={t.f_email} className="w-full px-4 py-3 rounded-lg border border-brand-blue-primary/15 focus:outline-none focus:ring-2 focus:ring-brand-blue-primary/50 text-sm" data-id="element-48" />
                  <input required type="tel" name="phone" placeholder={t.f_phone} className="w-full px-4 py-3 rounded-lg border border-brand-blue-primary/15 focus:outline-none focus:ring-2 focus:ring-brand-blue-primary/50 text-sm" data-id="element-49" />
                </div>

                <select required name="package" className="w-full px-4 py-3 rounded-lg border border-brand-blue-primary/15 focus:outline-none focus:ring-2 focus:ring-brand-blue-primary/50 text-sm bg-white text-brand-text-secondary" data-id="element-50">
                  <option value="" data-id="element-51">{t.f_pkg}</option>
                  <option value="Basico" data-id="element-52">{t.f_pkg_1}</option>
                  <option value="Profesional" data-id="element-53">{t.f_pkg_2}</option>
                  <option value="Premium" data-id="element-54">{t.f_pkg_3}</option>
                  <option value="Asesoria" data-id="element-55">{t.f_pkg_4}</option>
                </select>

                <textarea required name="message" rows={3} placeholder={t.f_msg} className="w-full px-4 py-3 rounded-lg border border-brand-blue-primary/15 focus:outline-none focus:ring-2 focus:ring-brand-blue-primary/50 text-sm resize-none" data-id="element-56"></textarea>

                <div className="space-y-2" data-id="element-57">
                  <label className="text-xs font-semibold text-brand-text-secondary uppercase" data-id="element-58">
                    {t.f_pref}
                  </label>
                  <div className="flex space-x-4" data-id="element-59">
                    {['Email', 'SMS', 'WhatsApp'].map((pref, i) => <label key={i} className="flex items-center space-x-2 cursor-pointer" data-id="element-60">
                        <input type="radio" name="contact_preference" value={pref} defaultChecked={i === 0} className="text-brand-blue-primary focus:ring-brand-blue-primary" data-id="element-61" />
                        <span className="text-sm text-brand-text-secondary" data-id="element-62">
                          {t[`f_pref_${i + 1}` as keyof typeof t]}
                        </span>
                      </label>)}
                  </div>
                </div>

                {status === 'error' && <p className="text-red-500 text-sm font-medium" data-id="element-63">
                    {t.f_error}
                  </p>}

                <button type="submit" disabled={status === 'sending'} className="w-full bg-gradient-button text-white py-4 rounded-xl font-bold shadow-md hover:shadow-lg transition-all hover:-translate-y-0.5 disabled:opacity-70 disabled:hover:translate-y-0" data-id="element-64">
                  {status === 'sending' ? t.f_btn_sending : t.f_btn}
                </button>

                <p className="text-[0.7rem] text-brand-text-muted text-center mt-4" data-id="element-65">
                  {t.f_priv.split('Política de Privacidad')[0]}
                  <button type="button" onClick={openPrivacy} className="underline hover:text-brand-blue-primary" data-id="element-66">
                    Política de Privacidad
                  </button>
                  {t.f_priv.split('Política de Privacidad')[1] || t.f_priv.split('Privacy Policy')[1]}
                  {lang === 'en' && t.f_priv.includes('Privacy Policy') && <button type="button" onClick={openPrivacy} className="underline hover:text-brand-blue-primary" data-id="element-67">
                      Privacy Policy
                    </button>}
                </p>
              </form>}
          </motion.div>
        </div>
      </div>
    </section>;
}